import { locationIdFormat } from "@redotech/redo-inventory-id";
import { FreightQuoteRequestSchema } from "@redotech/redo-model/freight/freight-quote-request";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

const RecommendedTransferLocationSchema_ = z.object({
  id: locationIdFormat.schema,
  name: z.string(),
});
export const RecommendedTransferLocationSchema: z.ZodType<RecommendedTransferLocation> =
  RecommendedTransferLocationSchema_;
export interface RecommendedTransferLocation extends z.infer<
  typeof RecommendedTransferLocationSchema_
> {}

const RecommendedTransferProductSchema_ = z.object({
  productId: productIdFormat.schema,
  sku: z.string(),
  title: z.string(),
  quantity: z.number().int().min(1),
  savedReroutedUnits: z.number().int().min(1),
});
export const RecommendedTransferProductSchema: z.ZodType<RecommendedTransferProduct> =
  RecommendedTransferProductSchema_;
export interface RecommendedTransferProduct extends z.infer<
  typeof RecommendedTransferProductSchema_
> {}

const RecommendedTransferSchema_ = z.object({
  originLocation: RecommendedTransferLocationSchema,
  destinationLocation: RecommendedTransferLocationSchema,
  savedReroutedUnits: z.number().int().min(1),
  totalTransferUnits: z.number().int().min(1),
  skuCount: z.number().int().min(1),
  productCount: z.number().int().min(1),
  transferLeadDays: z.number().int().min(0),
  products: z.array(RecommendedTransferProductSchema),
  freightQuoteRequest: FreightQuoteRequestSchema.nullable(),
});
export const RecommendedTransferSchema: z.ZodType<RecommendedTransfer> =
  RecommendedTransferSchema_;
export interface RecommendedTransfer extends z.infer<
  typeof RecommendedTransferSchema_
> {}

export const getRecommendedTransfer = {
  name: "getRecommendedTransfer" as const,
  input: z.null(),
  output: RecommendedTransferSchema.nullable(),
};
